enum IDComparisons{
    ID_EQUAL_TO = 'id',
    ID_NOT_EQUAL_TO = 'nid',
}

export default IDComparisons;